
import Vue from 'vue'
import { mapFields } from 'vuex-map-fields'
import HelperTooltip from '@/components/HelperTooltip.vue'
import ProductDialog from '@/components/ProductDialog.vue'
import { ProductLinkRegistry } from '@/types/ProductLinkRegistry'
import IProductDecription from '@/types/ProductDecription'

export default Vue.extend({
  components: {
    HelperTooltip,
    ProductDialog
  },

  props: {
    error: String
  },

  data: () => ({
    prodDesc: null as IProductDecription | null,
    selectedImage: '',
    showImageDialog: false
  }),

  computed: {
    ...mapFields({

      pro2TermostatProducts: 'termostatProductLists.pro2',
      techTermostatProducts: 'termostatProductLists.tech',
      heatmiserTermostatProducts: 'termostatProductLists.heatmiser',
      techAccessoryProducts: 'termostatProductLists.techAccessory',
      techWirelessAccessoryProducts: 'termostatProductLists.techWirelessAccessory',
      pcs: 'selectedTermostatProducts.pcs',
      mixPoints: 'selectedTermostatProducts.mixPoints',
      pro2SelectedTermostatProducts: 'selectedTermostatProducts.pro2',
      techSelectedTermostatProducts: 'selectedTermostatProducts.tech',
      heatmiserSelectedTermostatProducts: 'selectedTermostatProducts.heatmiser',
      techAccessorySelectedProducts: 'selectedTermostatProducts.techAccessory',
      techWirelessAccessorySelectedProducts: 'selectedTermostatProducts.techWirelessAccessory'
    }),

    filteredTechAccessories () {
      return (this as any).techAccessoryProducts.filter((product: string) => {
        if (product === 'WH-TMIX') {
          return this.mixPoints >= 1
        } else if (product === 'WH-TMFV2') {
          return this.mixPoints === 2
        } else if (product === 'WH-TMFV3') {
          return this.mixPoints === 3
        } else if (product === 'WH-TEMW' || product === 'WH-TEMV') {
          return this.mixPoints >= 2
        }

        return true
      })
    }
  },

  methods: {
    getProductLink (name: string): string | undefined {
      return ProductLinkRegistry.getLink(name)
    },

    getProductImg (name: string): string {
      return ProductLinkRegistry.getImg(name)
    },

    getProductName (name: string): string {
      return ProductLinkRegistry.getName(name)
    },

    getProductDesc (name: string): IProductDecription | null {
      return ProductLinkRegistry.getProductDescription(name)
    },

    openImageDialog (imageUrl: string, prodDesc: IProductDecription | null) {
      this.prodDesc = prodDesc || null
      this.selectedImage = imageUrl
      this.showImageDialog = true
    },

    onSelectSinglePro2 (selectedValue: string) {
      const arr = this.pro2SelectedTermostatProducts
      if (arr.includes(selectedValue)) {
        arr.splice(0, arr.length, selectedValue)
      }
      this.techSelectedTermostatProducts.splice(0, this.techSelectedTermostatProducts.length)
      this.heatmiserSelectedTermostatProducts.splice(0, this.heatmiserSelectedTermostatProducts.length)
      this.techAccessorySelectedProducts.splice(0, this.techAccessorySelectedProducts.length)
      this.techWirelessAccessorySelectedProducts.splice(0, this.techWirelessAccessorySelectedProducts.length)
    },

    onSelectSingleTech (selectedValue: string) {
      const arr = this.techSelectedTermostatProducts
      const exceptions = ['WH-TZV4B', 'WH-TZV4']
      const isException = exceptions.includes(selectedValue)
      if (arr.includes(selectedValue) && !isException) {
        const preserved = arr.filter((v: string) => exceptions.includes(v))
        arr.splice(0, arr.length, ...preserved, selectedValue)
      }
      this.pro2SelectedTermostatProducts.splice(0, this.pro2SelectedTermostatProducts.length)
      this.heatmiserSelectedTermostatProducts.splice(0, this.heatmiserSelectedTermostatProducts.length)
      this.techAccessorySelectedProducts.splice(0, this.techAccessorySelectedProducts.length)
      this.techWirelessAccessorySelectedProducts.splice(0, this.techWirelessAccessorySelectedProducts.length)
    },

    onSelectSingleHeatMiser (selectedValue: string) {
      const arr = this.heatmiserSelectedTermostatProducts
      if (arr.includes(selectedValue)) {
        arr.splice(0, arr.length, selectedValue)
      }
      this.pro2SelectedTermostatProducts.splice(0, this.pro2SelectedTermostatProducts.length)
      this.techSelectedTermostatProducts.splice(0, this.techSelectedTermostatProducts.length)
      this.techAccessorySelectedProducts.splice(0, this.techAccessorySelectedProducts.length)
      this.techWirelessAccessorySelectedProducts.splice(0, this.techWirelessAccessorySelectedProducts.length)
    }
  }
})

